"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvailableLicenses = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const components_1 = require("@smapiot/components");
const sorterFunctions_1 = require("./sorterFunctions");
const headers = [
    {
        id: 'product',
        cell: 'Product',
    },
    {
        id: 'expires',
        cell: 'Expires',
        width: '10rem',
    },
    {
        id: 'actions',
        cell: 'Actions',
        width: '7rem',
    },
];
const sorterFunctions = {
    expires: sorterFunctions_1.sortDateString,
};
const sortableHeaderIds = ['expires'];
function isTrialProductEntity(product) {
    return product.productId !== undefined;
}
function toRow(license, products, trialRequests, agreements, user) {
    const product = products === null || products === void 0 ? void 0 : products.find((c) => c.id === license.product);
    const trialRequest = trialRequests === null || trialRequests === void 0 ? void 0 : trialRequests.find((r) => r.licenseId === license.id);
    const agreement = agreements === null || agreements === void 0 ? void 0 : agreements.find((a) => a.id === (trialRequest === null || trialRequest === void 0 ? void 0 : trialRequest.trialProductAgreementId));
    return {
        id: license.id,
        cells: [
            user.role === 'admin' ? (isTrialProductEntity(product) ? (react_1.default.createElement("div", { className: "license-table-product-cell" },
                react_1.default.createElement("i", { className: "fas fa-circle", "data-checked": license.lastChecked }),
                react_1.default.createElement(react_router_dom_1.Link, { to: `/trial-products/edit/${license.product}` }, product === null || product === void 0 ? void 0 : product.name))) : (react_1.default.createElement("div", { className: "license-table-product-cell" },
                react_1.default.createElement("i", { className: "fas fa-circle", "data-checked": license.lastChecked }),
                react_1.default.createElement(react_router_dom_1.Link, { to: `/products/edit/${license.product}` }, product === null || product === void 0 ? void 0 : product.name)))) : (product === null || product === void 0 ? void 0 : product.name),
            new Date(license.expires).toLocaleDateString('de-DE'),
            react_1.default.createElement(components_1.ActionsRow, null,
                react_1.default.createElement(react_router_dom_1.Link, { to: `/licenses/view/${license.id}`, title: "View license", "data-eid": "license-action-view" },
                    react_1.default.createElement("i", { className: "fas fa-eye" })),
                isTrialProductEntity(product) && (react_1.default.createElement(react_1.default.Fragment, null,
                    agreement && (react_1.default.createElement("a", { href: agreement.link, target: "_blank", rel: "noreferrer", title: "View agreement", className: "s" },
                        react_1.default.createElement("i", { className: "fas fa-file-pdf" }))),
                    react_1.default.createElement(react_router_dom_1.Link, { to: `/trial-license/deployment/${license.id}`, title: "Deployment", "data-eid": "deployment-action-view" },
                        react_1.default.createElement("i", { className: "fas fa-rocket" }))))),
        ],
    };
}
const AvailableLicenses = ({ customerId, licenses, products, trialRequests, agreements, user }) => {
    customerId !== null && customerId !== void 0 ? customerId : (customerId = user === null || user === void 0 ? void 0 : user.company);
    licenses.sort((a, b) => new Date(a.expires).getTime() - new Date(b.expires).getTime());
    if (customerId) {
        const [sortedRows, sortedHeaders] = (0, components_1.useSortTable)(licenses === null || licenses === void 0 ? void 0 : licenses.map((l) => toRow(l, products, trialRequests, agreements, user)), headers, sorterFunctions, sortableHeaderIds);
        return licenses.length !== 0 ? (react_1.default.createElement(components_1.Table, { rows: sortedRows, headers: sortedHeaders })) : (react_1.default.createElement("h4", null, "There are currently no licenses."));
    }
    else {
        return react_1.default.createElement(components_1.StandardError, null);
    }
};
exports.AvailableLicenses = AvailableLicenses;
